import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PaymentMethod from "./PaymentMethod";
import { useCheckoutStore } from "../../../stores/checkoutStore"; // sesuaikan path sesuai struktur foldermu

const PaymentMethodPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { teleconsultationId } = useParams<{ teleconsultationId: string }>();
  const totalPrice = location.state?.totalPrice || 0;
  const pertanyaan = location.state?.pertanyaan || null;
  const { selectedPayment, selectedVoucher } = location.state || {};

  const setPayment = useCheckoutStore((s) => s.setPayment);

  return (
    <PaymentMethod
      totalPrice={totalPrice}
      defaultPayment={selectedPayment}
      onSelect={(payment, finalTotal) => {
        setPayment(payment);   // ⬅️ langsung tulis ke store, tidak lewat location.state lagi
        navigate(-1);          // ⬅️ kembali ke instance Checkout yang sudah ada, bukan mount baru
      }}
    />
  );
};

export default PaymentMethodPage;